export default function Terminos() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Términos y Condiciones</h1>

      <p className="mb-4">
        Bienvenido a nuestra tienda. Al acceder y utilizar este sitio web,
        aceptas los siguientes términos y condiciones. Te recomendamos leerlos
        detenidamente antes de realizar cualquier compra.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Uso del sitio</h2>
      <p className="mb-4">
        El uso de este sitio está destinado exclusivamente a mayores de edad.
        Queda prohibido usarlo con fines fraudulentos o actividades ilegales.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Productos</h2>
      <p className="mb-4">
        Hacemos nuestro mejor esfuerzo por mostrar los productos con precisión,
        pero los colores o detalles pueden variar según la pantalla del usuario.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Precios</h2>
      <p className="mb-4">
        Los precios pueden cambiar sin previo aviso. Toda compra se facturará
        con el valor vigente al momento de la transacción.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Pagos</h2>
      <p className="mb-4">
        Aceptamos métodos como PSE, Wompi, tarjetas débito y crédito. Las
        compras están sujetas a validación bancaria.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Envíos</h2>
      <p className="mb-4">
        Nuestros tiempos de entrega y operadores logísticos están detallados en
        la sección de Envíos.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Devoluciones</h2>
      <p className="mb-4">
        Las devoluciones se rigen según nuestra Política de Garantías y
        Devoluciones.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Modificaciones</h2>
      <p>
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las actualizaciones entran en vigor inmediatamente.
      </p>
    </div>
  );
}
